import {fonts} from '../../theme/foundations/fonts'
import {pxToRem} from '../../utills/pxToRem'

export const ctaListStyle = {
    align: 'center',
    mt: {base: `${pxToRem(20)} !important`, lg: `${pxToRem(25)} !important`},
    hr: {
        bgColor: 'rbga(0, 0, 0, 0.30)',
        margin: '0 !important'
    },
    'button, a': {
        _hover: {
            bg: 'none'
        },
        margin: '0 !important',
        minHeight: {base: pxToRem(42), lg: pxToRem(57)},
        fontFamily: fonts.primary,
        fontSize: {base: 'xs', lg: pxToRem(14)},
        fontStyle: 'normal',
        fontWeight: 'medium',
        lineHeight: 'normal',
        letterSpacing: {base: pxToRem(1), lg: pxToRem(2)},
        color: 'black',
        textTransform: 'uppercase',
        span: {
            mr: pxToRem(15)
        }
    }
}
